module.exports = __webpack_public_path__ + "static/media/series_placeholder.c2d23a77.png";